<template>
	<div>
		<template>
			<h2><i></i><span>{{ $root.t.deposit_now }}:</span></h2>
			<paymentForm />

		</template>
		<div class="mt-4">
			<h2><i></i><span>{{ $root.t.withdraw_now }}:</span></h2>
			<withdrawForm />
		</div>
	</div>
</template>

<script>
	import paymentForm from '@/components/payments/form/extend'
	import withdrawForm from '@/components/payments/form/extendWithdraw'
    export default {
        name: "papara",
        components: {withdrawForm,paymentForm}
    }
</script>

<style scoped>

	h2 > i{
		width: 100%;
		height: 100%;
		border-bottom: 3px solid #eee;
		display: block;
		float: left;
	}
	h2 {
		width: 100%;
		height: 50px;
		float: left;
		margin-bottom: 10px;
		position: relative;
		display: block;
	}
	h2 > span {
		color: blue;;
		float: left;
		font-size: 22px;
		height: 100%;
		min-width: 100px;
		border-bottom: 3px solid blue;
		padding: 10px 20px 10px 1px;
		text-transform: uppercase;
		bottom: 0px;
		left: 0px;
		position: absolute;
	}
</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/extend.vue